import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ReduxStates } from '../../../redux/reduxTypes';
import * as UserActions from '../../../redux/actions/user';
import { useOktaAuth } from '@okta/okta-react';

import { User as UserInterface } from '../../../types';
import { ReactComponent as UserIcon } from '../../../assets/icons/user-icon.svg';
import { ReactComponent as HelpIcon } from '../../../assets/icons/help-icon.svg';
import { ReactComponent as LogoutIcon } from '../../../assets/icons/logout-icon.svg';
import { ReactComponent as UploadIcon } from '../../../assets/icons/upload-icon.svg';
import { Link } from 'react-router-dom';

interface Props {
  user?: UserInterface;
  helpHref?: string;
}

const Options = ({ user, helpHref }: Props): React.ReactElement => {
  const { oktaAuth } = useOktaAuth();
  const history = useHistory();
  const dispatch = useDispatch();
  const copyData = useSelector((state: ReduxStates) => state.copyData);
  const userInfo = useSelector((state: ReduxStates) => state.user);
  const intervalId = useSelector((state: ReduxStates) => state.data.intervalId);

  const baseIconStyles = 'h-[15px] w-[15px] my-0 mx-[15px]';
  const optionContainerStyles =
    'flex items-center py-[15px] px-0 last:m-0 border-t last:border-[rgba(27,27,27,0.1)] last:cursor-pointer';
  const optionParagraphStyles = 'font-nunitoRegular text-xs m-0';
  return (
    <div className="z-[100] absolute bg-white top-[50px] right-[-20px] w-[218px] rounded shadow-navOptionsShadow">
      <div className="flex items-center py-[15px] px-0">
        <UserIcon className={baseIconStyles} />
        <div className="text-[11px] m-0">
          <p className="text-xs font-nunitoMedium">{user?.name}</p>
          <p>{user?.email}</p>
        </div>
      </div>
      {userInfo.userModules && userInfo.userModules.includes('Upload Data') && (
        <Link to="/account/data-management">
          <div className={optionContainerStyles}>
            <UploadIcon className={baseIconStyles} />
            <p className={optionParagraphStyles}>{copyData?.account_manage_data}</p>
          </div>
        </Link>
      )}
      <a href={helpHref} target="_blank">
        <div className={optionContainerStyles}>
          <HelpIcon className={baseIconStyles} />
          <p className={optionParagraphStyles}>{copyData?.account_help}</p>
        </div>
      </a>
      <div
        className={optionContainerStyles}
        onClick={() => {
          oktaAuth.tokenManager.clear();
          history.push('/login');
          clearInterval(intervalId);
          // window.location.reload();
          dispatch(UserActions.setUserLogin(false));
          dispatch(UserActions.setUserModules(null));
        }}
      >
        <LogoutIcon className={baseIconStyles} />
        <p className={optionParagraphStyles}>{copyData?.account_logout}</p>
      </div>
    </div>
  );
};

export default Options;
